export class SelectItem {
    constructor(
        public value: number | string,
        public text: string
    ) { }
}
